module.exports = __webpack_public_path__ + "static/media/Ubuntu-Bold.b5d4adff.ttf";